class ShareButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.button.addEventListener("click", () => this.share());
  }

  async share() {
    const url = window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          url: url
        });
      } catch (e) {
        console.log("Share cancelled");
      }
      return;
    }

    // fallback
    await navigator.clipboard.writeText(url);
    this.flashMessage("Link copied!");
  }

  flashMessage(text) {
    let msg = this.querySelector(".share-msg");

    if (!msg) {
      msg = document.createElement("div");
      msg.className = "share-msg";
      this.appendChild(msg);
    }

    msg.textContent = text;

    setTimeout(() => {
      msg.textContent = "";
    }, 1500);
  }
}

customElements.define("share-button", ShareButton);